
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.side-by-side-container{display:grid;gap:var(--spacing-20);grid-template-areas:"sidebar main";grid-template-columns:2fr 5fr;grid-template-rows:auto}.side-by-side-container.right{grid-template-columns:5fr 2fr}.side-by-side-container.isMobile{gap:var(--gap-2lg);grid-template-areas:"sidebar" "main";grid-template-columns:1fr;grid-template-rows:auto}.side-container{grid-area:sidebar}.content-container{grid-area:main}`;